import { render, staticRenderFns } from "./ChatMessageModal.vue?vue&type=template&id=3b9f5ede&scoped=true&"
import script from "./ChatMessageModal.vue?vue&type=script&lang=js&"
export * from "./ChatMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageModal.vue?vue&type=style&index=0&id=3b9f5ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f5ede",
  null
  
)

export default component.exports